require('angular').module('clientDashboardApp.reviewBuilder').directive('visibilityIndicator', ['$timeout', function($timeout) {
  return {
    restrict: 'E',
    scope: {
      isPublic: '=',
      isEditable: '='
    },
    template: require('./visibilityIndicator.html'),
    link: function (scope) {

    },
    controller: ['$scope', function($scope) {

      $scope.tooltipPublic = "Anyone on your account is able to use this in their campaigns";
      $scope.tooltipPrivate = "This will only be accessible by you and your account administrators";
      $scope.tooltip = $scope.isPublic ? $scope.tooltipPublic : $scope.tooltipPrivate; // for when !isEditable
      $scope.setPublic = function(isPublic) {
        $timeout(function () {
          if ($scope.isEditable) {
            $scope.isPublic = isPublic;
          }
        })
      }
    }]
  }
}])
